// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { BaseModel, Selectable, Resource, deserializeString } from '@patterns/core'

@Resource('employees')
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export class Employee extends BaseModel implements Selectable {
  name: string
  classification: string

  constructor(data: any = {}) {
    super(data);
    this.name = deserializeString(data.name);
    this.classification = deserializeString(data.classification);
  }

  getLabel() { return '' }
  getTitle() { return this.name }
}

